import { render } from "./SSection.vue?vue&type=template&id=2783582a"
import script from "./SSection.vue?vue&type=script&lang=js"
export * from "./SSection.vue?vue&type=script&lang=js"

import "./SSection.vue?vue&type=style&index=0&id=2783582a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__